import { render, staticRenderFns } from "./copyerDrawer.vue?vue&type=template&id=4ebbb564&"
import script from "./copyerDrawer.vue?vue&type=script&lang=js&"
export * from "./copyerDrawer.vue?vue&type=script&lang=js&"
import style0 from "./copyerDrawer.vue?vue&type=style&index=0&id=4ebbb564&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports